import request from './request';

const EventService = {
  getAll: (params) => request.get('/admin/getAllEvents', { params }),
delete: (id) => request.delete(`/admin/deleteEvent/${id}`)

};

export default EventService;
